import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EastIcon(props: IconProps) {
    return <Icon {...props} iconKey={"east"}/>
}
